export default __webpack_public_path__ + "static/media/HashMap Visual.40c9210f.svg";